/* eslint-disable */
(function promobannerScript($, Drupal) {
  Drupal.behaviors.promobanner = {
    attach(context) {

      // Here we hide the block by defualt, and only show if a user does not close it out.
      // This way the block will never show up on pages after a user clicks close.

      // Look for promo banner
      let promoCloseBtn = $('#block-promobanner').find('.promo-banner__icon');

      // Get the current time.
      const currTime = (new Date()).getTime();

      // On click of button hide.
      $(promoCloseBtn).on('click', function() {
        $('#block-promobanner').hide();

        // Set local storage with current time.
        localStorage.setItem('lastclear', currTime);
      })

      // If promoBanner local storage is not set we show it.
      if (localStorage.getItem("lastclear") === null) {
        
        $('#block-promobanner').show();

      } else {

        const lastclear = localStorage.getItem('lastclear');
        const days = 1000 * 60 * 60 * 7;

        // Ensures that the banner reappears after 7 days, bust local and show banner.
        if ((currTime - lastclear) > days) {
          localStorage.clear();
          $('#block-promobanner').show();
        }

      }

      // Check if the url has seafood, if so show the seafood banner.
      if (window.location.href.indexOf('/topic/sustainable-seafood') > -1 || window.location.href.indexOf('/species-directory/sustainable-seafood') > -1) {

        if ($('#block-seafoodpromo').find('img').length){
          $('#block-seafoodpromo').show();
        }
      }

      // if page has seafood div?
      $('.sub-nav__link').each(function() {
        if (this.href.indexOf('/seafood') != -1) {
          $('#block-seafoodpromo').show();
        }
      });
    
    },
  };
}(jQuery, Drupal));
/* eslint-enable */
